import { makeUseMessage, makeUseMessages } from "./auth-service-tools29.js";
makeUseMessage();
const useMessages = makeUseMessages();
export { useMessages };